import { render, staticRenderFns } from "./spider-analyzer.vue?vue&type=template&id=9b4aa8e4&scoped=true&"
import script from "./spider-analyzer.vue?vue&type=script&lang=ts&"
export * from "./spider-analyzer.vue?vue&type=script&lang=ts&"
import style0 from "./spider-analyzer.vue?vue&type=style&index=0&id=9b4aa8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4aa8e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VDialog,VIcon,VTextField,VTooltip})
